import React from "react";
import { PeopleOutline, TimeOutline, ListOutline, BarChartOutline, LogOutOutline, CalendarOutline, MedkitOutline, ClipboardOutline, PersonOutline } from 'react-ionicons'
import stylesMed from "./stylesMed"
import constantURI from "../URI"
import _post from "../Functions/Post"
import Authenticate from "../Functions/MedRepAuthenticate"

function convertNumToTime(number) {
    var sign = (number >= 0) ? 1 : -1;
    number = number * sign;
    var hour = Math.floor(number);
    var decpart = number - hour;
    var min = 1 / 60;
    decpart = min * Math.round(decpart / min);
    var minute = Math.floor(decpart * 60) + '';
    if (minute.length < 2) {
        minute = '0' + minute;
    }
    sign = sign == 1 ? '' : '-';
    var time = sign + hour + ':' + minute;
    return time;
}

export default class LandingPageRep extends React.Component {

    constructor() {
        super();
        this.state = {
            isSupervisor: "",
            Rep: false,
            limits: [],
            token: "",
            todaysDate: new Date().toISOString().substring(0, 10),
            beginDate: new Date(),
            authenticate: false,
            loading: true,
            alertUndefined: false
        }
    }

    async componentDidMount() {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        var user = localStorage.getItem("isSupervisor");
        var token = localStorage.getItem("Token");
        await this.setState({ isSupervisor: JSON.parse(user), token: JSON.parse(token) });
        if (this.state.isSupervisor) {
            this.setState({ Rep: false, loading: false });
        }
        else {
            this.setState({ Rep: true, loading: false });
        }
        const clientsURL = constantURI() + "odooController/MedRepRead";
        const RepsBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "medrepsettings",
                "args": [],
                "kwargs": {
                    "fields": ["in_time", "out_time", "out_of_rout_visit"],
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(clientsURL, RepsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ limits: data.result });
                        localStorage.setItem('Limits', JSON.stringify(this.state.limits));
                    } else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const limits = localStorage.getItem('Limits');
            await this.setState({ limits: JSON.parse(limits) });
        }
    }

    onClickAddVisit = () => {
        if (new Date().getTime() >= new Date(this.state.todaysDate + " " + convertNumToTime(this.state.limits[0].in_time)).getTime() && new Date().getTime() <= new Date(this.state.todaysDate + " " + convertNumToTime(this.state.limits[0].out_time)).getTime()) {
            this.props.history.push('/AddVisit');
        }
        else {
            alert("You are allowed to create visits during these times: between " + convertNumToTime(this.state.limits[0].in_time) + " and " + convertNumToTime(this.state.limits[0].out_time));
        }
    }

    beginDate = async () => {
        var tzoffset = (new Date()).getTimezoneOffset() * 60000;
        var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(11, 19);
        await this.setState({ beginDate: localISOTime })
        alert("Your day has started at " + this.state.beginDate);
        localStorage.setItem("Begin Date", JSON.stringify(this.state.beginDate));
    }

    render() {
        if (!this.state.loading) {
            return (
                <div className="vh-100" style={stylesMed.mainContainer}>
                    {(!this.state.alertUndefined) ?
                        null :
                        <div className="col alert alert-danger">
                            <div className="row">
                                <h6 className="col-sm-8">There seems to be a problem.</h6>
                                <div className="col d-flex flex-row-reverse">
                                    <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                        Reload</div>
                                </div>
                            </div>
                        </div>
                    }
                    {/*<div className="row pt-3">*/}
                    {/*    <div className="col mt-2 d-flex flex-row-reverse">*/}
                    {/*        <div className="btn" data-toggle="modal" data-target="#myModal" style={stylesMed.wideButton} onClick={() => this.beginDate()}>Begin Date</div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="d-flex flex-row pt-3" >
                        <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => this.props.history.push('/HCPs')}>
                            <PeopleOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                            <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>HCPs</p>
                        </div>
                        <div className="col-sm-1"></div>
                        <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => this.props.history.push('/DailySchedule')}>
                            <TimeOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                            <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Daily Schedule</p>
                        </div>
                    </div>
                    {(this.state.Rep) ?
                        <div>
                            <div className="d-flex flex-row pt-5">
                                {/*onClick={this.onClickAddVisit}*/}
                                <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => this.props.history.push('/AddVisit')}>
                                    <ClipboardOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Add Visit</p>
                                </div>
                                <div className="col-sm-1"></div>
                                <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => { this.props.history.push('/AddActivity'); localStorage.setItem("CheckedDoctors", JSON.stringify([])) }}>
                                    <ListOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Add Activity</p>
                                </div>
                            </div>
                            <div className="d-flex flex-row pt-5">
                                <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => { this.props.history.push('/Plan'); localStorage.setItem("SelectedRep", JSON.stringify("")); }}>
                                    <CalendarOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Plan</p>
                                </div>
                                <div className="col-sm-1"></div>
                                <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => this.props.history.push('/Products')}>
                                    <MedkitOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Products</p>
                                </div>
                            </div>
                            <div className="d-flex flex-row pt-5">
                                <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => this.props.history.push('./Reports')}>
                                    <BarChartOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Reports</p>
                                </div>
                                <div className="col-sm-1"></div>
                                <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => this.props.history.push('./')}>
                                    <LogOutOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Logout</p>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className="d-flex flex-row pt-5">
                                <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => { this.props.history.push('/Plan'); localStorage.setItem("SelectedRep", JSON.stringify("")); }}>
                                    <PersonOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Representative</p>
                                </div>
                                <div className="col-sm-1"></div>
                                <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => this.props.history.push('./Reports')}>
                                    <BarChartOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Reports</p>
                                </div>
                            </div>
                            <div className="d-flex flex-row pt-5">
                                <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => this.props.history.push('./CoachingPlanner')}>
                                    <CalendarOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Coaching Planner</p>
                                </div>
                                <div className="col-sm-1"></div>
                                <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => this.props.history.push('./')}>
                                    <LogOutOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                    <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Logout</p>
                                </div>
                                {/*<div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => this.props.history.push('./Tracking')}>*/}
                                {/*    <LocationOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />*/}
                                {/*    <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Tracking Reps</p>*/}
                                {/*</div>*/}
                            </div>
                            {/*<div className="d-flex flex-row pt-5">*/}
                            {/*    <div className="btn card flex-fill text-center bg-light pt-3" style={stylesMed.LandingModules} onClick={() => this.props.history.push('./')}>*/}
                            {/*        <LogOutOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />*/}
                            {/*        <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Logout</p>*/}
                            {/*    </div>*/}
                            {/*    <div className="col-sm-1"></div>*/}
                            {/*    <div className="btn card flex-fill text-center bg-light pt-3 invisible" style={stylesMed.LandingModules} onClick={() => this.props.history.push('./')}>*/}
                            {/*        <LogOutOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />*/}
                            {/*        <p className="card-text" style={{ color: "#00bfff", fontSize: 20 }}>Logout</p>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    }
                </div>
            )
        }
        else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }
    }
}
